import { render } from "./ClientClientesVer.vue?vue&type=template&id=580f95b8&scoped=true"
import script from "./ClientClientesVer.vue?vue&type=script&lang=js"
export * from "./ClientClientesVer.vue?vue&type=script&lang=js"

import "./ClientClientesVer.vue?vue&type=style&index=0&id=580f95b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580f95b8"]])

export default __exports__